import { gqlType } from "@hifieng/common";
import { MapEvent } from "../types/EventMap";

type PipelineOffsetConfigType = {
  offsetDirection: string;
  offsetDistanceMeters: number;
};

/* cspell:disable */
/* eslint-disable @typescript-eslint/camelcase */
const PIPELINES_TO_OFFSET: Record<string, PipelineOffsetConfigType> = {
  paramount_leafland_hc: {
    offsetDirection: "se",
    offsetDistanceMeters: 400
  }
};
/* eslint-enable @typescript-eslint/camelcase */
/* cspell:enable */

const DIRECTIONS: Record<string, Array<number>> = {
  n: [0.0, 1.0],
  s: [0.0, -1.0],
  e: [1.0, 0.0],
  w: [-1.0, 0.0],
  ne: [1.0, 1.0],
  nw: [-1.0, 1.0],
  se: [1.0, -1.0],
  sw: [-1.0, -1.0]
};

const METERS_PER_DEGREE_LAT = 111320;
const DEGREES_PER_HALF_TURN = 180;

const toRadians = (degrees: number): number => {
  return degrees * (Math.PI / DEGREES_PER_HALF_TURN);
};

const offsetCoordinate = (
  coordinate: gqlType.Coordinates,
  direction: string,
  distanceMeters: number
): gqlType.Coordinates => {
  const directionVector = DIRECTIONS[direction.toLowerCase()];
  if (!directionVector) {
    throw new Error(
      `Invalid direction: ${direction}. Must be one of: ${Object.keys(
        DIRECTIONS
      ).join(", ")}`
    );
  }

  const [dx, dy] = directionVector;
  const magnitude = Math.sqrt(Number(dx * dx) + Number(dy * dy));
  const offsetDx = (dx / magnitude) * distanceMeters;
  const offsetDy = (dy / magnitude) * distanceMeters;
  const latitude = Number(coordinate.latitude);
  const longitude = Number(coordinate.longitude);

  const newLat = latitude + offsetDy / METERS_PER_DEGREE_LAT;
  const newLon =
    longitude +
    offsetDx / (METERS_PER_DEGREE_LAT * Math.cos(toRadians(latitude)));

  return {
    latitude: newLat,
    longitude: newLon
  };
};

export const applyOffset = (
  coordinates: gqlType.Coordinates,
  pipelineId: string
): gqlType.Coordinates => {
  if (pipelineId in PIPELINES_TO_OFFSET) {
    return offsetCoordinate(
      coordinates,
      PIPELINES_TO_OFFSET[pipelineId].offsetDirection,
      PIPELINES_TO_OFFSET[pipelineId].offsetDistanceMeters
    );
  } else {
    return coordinates;
  }
};

export const offsetEventCoordinates = (
  event: MapEvent,
  direction: string,
  distanceMeters: number
): MapEvent => {
  if (!event.coordinates) {
    return event;
  }

  const offsetCoords = offsetCoordinate(
    event.coordinates,
    direction,
    distanceMeters
  );

  return {
    ...event,
    coordinates: offsetCoords
  };
};
